import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TripReviewService from '../../api/services/TripReviewService';
import MainPagetitle from '../../layouts/MainPagetitle';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const EditTravel = () => {
  const navigate = useNavigate();
  var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL + 'Tripplan/';
  const params = useParams();
  const [isLoading, setisloading] = useState(true);
  const [file, setFile] = useState()
  const [TripData, setTripData] = useState([]);
  const [error, setError] = useState([]);
  const [gallery, setGallery] = useState([])
  const [description, setDescription] = useState("");
  const [Germandescription, setGermanDescription] = useState("");
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {
      var id = params.id;
      getTripById(id);
    }
    else {
      navigate('/')
    }
  }, []);
  const getTripById = async (id) => {
    try {
      let driving = await TripReviewService.show(id).json();
      setTripData(driving.data);
      const galleryImageList = driving.data.gallery.map((element) => {
        return imageUrl + element
      })
      setGallery(galleryImageList)
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const handleEditorChange = (e, editor) => {
    const data = editor.getData()
    setDescription(data);
  }
  const handleEditorChangeGerman = (e, editor) => {
    const data = editor.getData()
    setGermanDescription(data);
  }

  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var blog_image = fileReader.result
      setFile(blog_image)
    }
  }
  
  const onFileGallery = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var logo = fileReader.result
      setGallery([...gallery, logo]);

    }
  }
  let removeImageFields = (i) => {
    let values = [...gallery];
    values.splice(i, 1);
    setGallery(values)
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title": event.target.de_title.value,
        "description": description,
        "de_description": Germandescription,
        "price": event.target.startprice.value,
        "image": file ? file.split(',')[1] : "",
        "gallery": gallery ? gallery :""
       
      }
      
      let responseData = await TripReviewService.update(params.id,userData).json()
      if (responseData.status === true) {
        navigate("/admin/manage_travel");
      }
      setError(responseData.errors)
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message)
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Edit Travel Planner" pageTitle={'Edit Travel Planner'} parentTitle={'Home'} />
      <div className="container-fluid">
        <form className="form-valide" onSubmit={onSubmitForm}>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title"> Edit Travel Planner</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" defaultValue={
                        TripData.title
                          ? TripData.title
                          : ''
                      } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" defaultValue={
                        TripData.de_title
                          ? TripData.de_title
                          : ''
                      } />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> English Description <span className="text-danger">*</span></label>
                      <div className="custom-ekeditor">
                        <CKEditor
                          editor={ClassicEditor}
                          name="description"
                          data={TripData ? TripData.description : ''}
                          onChange={handleEditorChange}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> German Description <span className="text-danger">*</span></label>
                      <div className="custom-ekeditor">
                        <CKEditor
                          editor={ClassicEditor}
                          name="de_description"
                          data={TripData ? TripData.de_description : ''}
                          onChange={handleEditorChangeGerman}
                        />
                      </div>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label"> Image <span className="text-danger">*</span></label>

                      <img className="img-drop-area" height={100} width={100} src={file ? file : imageUrl + TripData.image} alt='' />
                      <input type="file" className="form-control" name='blog_image' id="val-number" accept="image/png, image/jpeg" onChange={onFileChange} />

                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Price<span className="text-danger">*</span></label>
                      <input type="number" className="form-control" name='startprice' id="startprice" placeholder="" defaultValue={
                        TripData.price
                          ? TripData.price
                          : ''
                      } />
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-xl-12 mb-3">
                          <label className="form-label" htmlFor="val-suggestions">Camper Gallery  <span className="text-danger">*</span></label>
                          {gallery.length > 0 &&
                            gallery.map((item, index) => {
                              return (
                                <div key={item}>
                                  <img src={item} alt="" height={100} width={100} />
                                  <button type="button" className="button remove mt-3 p-2" onClick={() => removeImageFields(index)}>Remove</button>
                                </div>
                              );
                            })}
                          <input type="file" className="form-control" name='image' id="val-number" onChange={onFileGallery} accept="image/png, image/jpeg" />
                        </div></div></div>
                  </div>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                  <span class="span-error">{error}</span>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
      {isLoading && <LogoAnimationLoader />}
    </>
  );
};
export default EditTravel;